(()=>{
  if(window.ctProductBlackFridayOfferReady)return;
  window.ctProductBlackFridayOfferReady=true;
  const fallbackCopy=text=>{
    const input=document.createElement('textarea');
    input.value=text;input.setAttribute('readonly','');
    input.style.cssText='position:fixed;opacity:0;pointer-events:none';
    document.body.appendChild(input);
    try{input.select();return document.execCommand('copy');}
    finally{input.remove();}
  };
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-ct-bf-copy]');
    if(!button)return;
    const code=button.dataset.ctBfCopy;
    const offer=button.closest('[data-ct-bf-offer]');
    const label=button.querySelector('[data-ct-bf-copy-label]');
    const status=offer.querySelector('[data-ct-bf-copy-status]');
    let copied=false;
    try{await navigator.clipboard.writeText(code);copied=true;}
    catch(_){try{copied=fallbackCopy(code);}catch(_){copied=false;}}
    if(!copied){status.textContent=`Please select and copy ${code}.`;return;}
    button.focus({preventScroll:true});
    button.dataset.copied='true';label.textContent='Copied';
    status.textContent=`Discount code ${code} copied.`;
    clearTimeout(button.ctBfResetTimer);
    button.ctBfResetTimer=setTimeout(()=>{delete button.dataset.copied;label.textContent='Copy';status.textContent='';},1800);
  });
})();
